module.exports = __webpack_public_path__ + "static/media/summit.969a1def.gif";